import { FAKE, fakeDelay } from "../fake";
import type { GeoPayload, GeoVerifyResult } from "../types";

/**
 * 地理围栏：上报定位载荷做合规判定。
 *
 * 【假数据】后端还没有这个接口，先按 fake.ts 的开关返回。
 * 接真接口时换成 POST /api/geo/verify（带 latitude/longitude/accuracy/externalId/
 * externalEmail），并把失败兜底按 fail-closed 处理 —— 判不出来就当不合规，
 * 与合规文档里客户端 onError 回调（isCompliant=false, score=100）一致，
 * 地理围栏本身就是合规闸门，放行等于闸门失效。
 */
export const verifyGeoPayload = (
  payload: GeoPayload
): Promise<GeoVerifyResult> => {
  // 签名先按真接口的样子留着，假实现用不上；接真接口时它就是请求体
  void payload;
  return fakeDelay({
    compliant: FAKE.geoCompliant,
    score: FAKE.geoCompliant ? 0 : 100,
  });
};
